// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3Tkz6","ScrollX":"Scroll_ScrollX__2sE7C","ScrollY":"Scroll_ScrollY__G0yG_"};